function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}

function getLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

function darkenColor(hex, amount = 0.2) {
  const { r, g, b } = hexToRgb(hex);
  const f = 1 - amount;
  return `rgb(${Math.round(r * f)}, ${Math.round(g * f)}, ${Math.round(b * f)})`;
}

export function getDarkBrand(brandColor) {
  const lum = getLuminance(brandColor);
  return lum > 0.55 ? darkenColor(brandColor, 0.3) : brandColor;
}

export function getContentCSS(template, brandColor) {
  const dark = getDarkBrand(brandColor);
  const I = ' !important';

  const base = `
    body { margin: 0${I}; padding: 24px${I}; box-sizing: border-box${I}; }
    img { max-width: 100%${I}; height: auto${I}; }
    table { width: 100%${I}; border-collapse: collapse${I}; margin: 16px 0${I}; }
    a { color: ${dark}${I}; }
    a:hover { opacity: 0.8${I}; }
    * { max-width: 100%${I}; box-sizing: border-box${I}; }
  `;

  if (template === 'minimal') return `<style>
    ${base}
    body, body > div, body > div > * { font-family: -apple-system, "Helvetica Neue", Arial, sans-serif${I}; font-size: 15px${I}; line-height: 1.9${I}; color: #333${I}; font-weight: 300${I}; letter-spacing: 0.3px${I}; }
    h1, h2, h3, h4, h5 { font-weight: 300${I}; letter-spacing: 1px${I}; text-transform: uppercase${I}; border-bottom: 2px solid ${dark}${I}; display: inline-block${I}; padding-bottom: 4px${I}; margin-top: 28px${I}; background: none${I}; -webkit-background-clip: unset${I}; -webkit-text-fill-color: unset${I}; }
    h1 { font-size: 28px${I}; } h2 { font-size: 22px${I}; } h3 { font-size: 18px${I}; }
    p { margin: 12px 0${I}; line-height: 1.9${I}; }
    ul, ol { padding-left: 20px${I}; }
    li { margin: 6px 0${I}; line-height: 1.9${I}; }
    blockquote { margin: 20px 0${I}; padding: 16px 20px${I}; border-left: none${I}; font-style: italic${I}; background: #fafafa${I}; color: #555${I}; border-radius: 0${I}; }
    table th { background: transparent${I}; border-bottom: 2px solid ${dark}${I}; padding: 10px 12px${I}; text-align: left${I}; font-weight: 400${I}; letter-spacing: 0.5px${I}; text-transform: uppercase${I}; font-size: 13px${I}; color: #333${I}; }
    table td { padding: 10px 12px${I}; border-bottom: 1px solid #eee${I}; }
    table tr:hover td { background: #fafafa${I}; }
    button, input[type="submit"], .btn { background: transparent${I}; color: ${dark}${I}; border: 2px solid ${dark}${I}; padding: 10px 24px${I}; cursor: pointer${I}; font-size: 14px${I}; letter-spacing: 1px${I}; border-radius: 0${I}; }
    button:hover, input[type="submit"]:hover, .btn:hover { background: ${dark}${I}; color: #fff${I}; }
    input, textarea, select { border: none${I}; border-bottom: 1.5px solid #ccc${I}; padding: 8px 0${I}; font-size: 14px${I}; outline: none${I}; width: 100%${I}; background: transparent${I}; border-radius: 0${I}; }
    input:focus, textarea:focus, select:focus { border-bottom-color: ${dark}${I}; }
    hr { border: none${I}; border-top: 1px solid #e8e8e8${I}; margin: 24px 0${I}; }
    div[style*="border-radius"] { border-radius: 0${I}; }
    div[style*="background: linear-gradient"], div[style*="background:linear-gradient"] { background: #fafafa${I}; }
  </style>`;

  if (template === 'classic') return `<style>
    ${base}
    body, body > div, body > div > * { font-family: Georgia, "Times New Roman", "Noto Serif TC", serif${I}; font-size: 15px${I}; line-height: 1.75${I}; color: #2c2c2c${I}; }
    h1, h2, h3, h4, h5 { font-family: Georgia, "Noto Serif TC", serif${I}; font-weight: 700${I}; margin-top: 28px${I}; color: #1a1a1a${I}; background: none${I}; -webkit-background-clip: unset${I}; -webkit-text-fill-color: unset${I}; }
    h1 { font-size: 30px${I}; border-bottom: 1px solid #ddd${I}; padding-bottom: 8px${I}; } h2 { font-size: 24px${I}; } h3 { font-size: 20px${I}; }
    p { margin: 12px 0${I}; line-height: 1.75${I}; }
    ul, ol { padding-left: 24px${I}; }
    li { margin: 4px 0${I}; line-height: 1.75${I}; }
    blockquote { margin: 20px 0${I}; padding: 16px 20px${I}; border-left: 4px solid ${dark}${I}; background: #f9f9f9${I}; font-style: italic${I}; border-radius: 0${I}; }
    table th { background: ${dark}${I}; color: #fff${I}; padding: 10px 14px${I}; text-align: left${I}; font-weight: 600${I}; }
    table td { padding: 10px 14px${I}; border: 1px solid #ddd${I}; }
    table tr:nth-child(even) td { background: #f9f9f9${I}; }
    button, input[type="submit"], .btn { background: ${dark}${I}; color: #fff${I}; border: none${I}; padding: 10px 24px${I}; cursor: pointer${I}; font-size: 14px${I}; border-radius: 4px${I}; font-family: Georgia, serif${I}; }
    button:hover, input[type="submit"]:hover, .btn:hover { opacity: 0.9${I}; }
    input, textarea, select { border: 1px solid #ccc${I}; padding: 8px 12px${I}; font-size: 14px${I}; border-radius: 4px${I}; width: 100%${I}; box-sizing: border-box${I}; font-family: Georgia, serif${I}; }
    input:focus, textarea:focus, select:focus { border-color: ${dark}${I}; outline: none${I}; }
    hr { border: none${I}; border-top: 1px solid #ddd${I}; margin: 24px 0${I}; }
    div[style*="border-radius"] { border-radius: 4px${I}; }
    div[style*="background: linear-gradient"], div[style*="background:linear-gradient"] { background: #f9f9f9${I}; }
  </style>`;

  // modern (default)
  return `<style>
    ${base}
    body, body > div, body > div > * { font-family: -apple-system, "Helvetica Neue", "PingFang SC", "Microsoft YaHei", sans-serif${I}; font-size: 15px${I}; line-height: 1.75${I}; color: #333${I}; }
    h1, h2, h3, h4, h5 { font-weight: 700${I}; color: #1a1a2e${I}; margin-top: 28px${I}; }
    h1 { font-size: 32px${I}; } h2 { font-size: 26px${I}; } h3 { font-size: 20px${I}; }
    p { margin: 12px 0${I}; line-height: 1.75${I}; }
    ul, ol { padding-left: 24px${I}; }
    li { margin: 6px 0${I}; line-height: 1.75${I}; }
    blockquote { margin: 20px 0${I}; padding: 16px 24px${I}; border-left: 4px solid ${dark}${I}; background: linear-gradient(135deg, ${brandColor}08, ${brandColor}15)${I}; border-radius: 8px${I}; }
    table th { background: linear-gradient(135deg, ${dark}, ${darkenColor(dark, 0.15)})${I}; color: #fff${I}; padding: 12px 14px${I}; text-align: left${I}; font-weight: 600${I}; }
    table th:first-child { border-radius: 8px 0 0 0${I}; }
    table th:last-child { border-radius: 0 8px 0 0${I}; }
    table td { padding: 12px 14px${I}; border-bottom: 1px solid #f0f0f0${I}; }
    table tr:hover td { background: ${brandColor}08${I}; }
    button, input[type="submit"], .btn { background: linear-gradient(135deg, ${dark}, ${darkenColor(dark, 0.15)})${I}; color: #fff${I}; border: none${I}; padding: 10px 28px${I}; cursor: pointer${I}; font-size: 14px${I}; border-radius: 24px${I}; font-weight: 600${I}; }
    button:hover, input[type="submit"]:hover, .btn:hover { opacity: 0.9${I}; box-shadow: 0 4px 12px ${brandColor}40${I}; }
    input, textarea, select { border: 1px solid #e0e0e0${I}; padding: 10px 14px${I}; font-size: 14px${I}; border-radius: 8px${I}; width: 100%${I}; box-sizing: border-box${I}; transition: border-color 0.2s${I}; }
    input:focus, textarea:focus, select:focus { border-color: ${dark}${I}; outline: none${I}; box-shadow: 0 0 0 3px ${brandColor}20${I}; }
    hr { border: none${I}; border-top: 1px solid #f0f0f0${I}; margin: 24px 0${I}; }
  </style>`;
}

export function wrapSnippetAsFullPage(html, cssTag) {
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1">${cssTag}</head><body>${html}</body></html>`;
}

export function getContentWrapperStyle(template) {
  if (template === 'minimal') return {
    fontFamily: '-apple-system, "Helvetica Neue", Arial, sans-serif',
    fontSize: 15,
    lineHeight: 1.9,
    color: '#333',
    fontWeight: 300,
    letterSpacing: '0.3px',
  };

  if (template === 'classic') return {
    fontFamily: 'Georgia, "Times New Roman", "Noto Serif TC", serif',
    fontSize: 15,
    lineHeight: 1.75,
    color: '#2c2c2c',
  };

  return {
    fontFamily: '-apple-system, "Helvetica Neue", "PingFang SC", "Microsoft YaHei", sans-serif',
    fontSize: 15,
    lineHeight: 1.75,
    color: '#333',
  };
}

export function getAntdThemeTokens(template, brandColor) {
  const dark = getDarkBrand(brandColor);

  if (template === 'minimal') return {
    colorPrimary: dark,
    borderRadius: 0,
    fontFamily: '-apple-system, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
  };

  if (template === 'classic') return {
    colorPrimary: dark,
    borderRadius: 4,
    fontFamily: 'Georgia, "Times New Roman", "Noto Serif TC", serif',
    fontSize: 14,
  };

  return {
    colorPrimary: dark,
    borderRadius: 8,
    fontFamily: '-apple-system, "Helvetica Neue", "PingFang SC", "Microsoft YaHei", sans-serif',
    fontSize: 14,
  };
}

export function injectStyleIntoHTML(html, cssTag) {
  if (!html) return html;
  const headClose = html.indexOf('</head>');
  if (headClose !== -1) {
    return html.slice(0, headClose) + cssTag + html.slice(headClose);
  }
  const bodyOpen = html.indexOf('<body');
  if (bodyOpen !== -1) {
    return html.slice(0, bodyOpen) + cssTag + html.slice(bodyOpen);
  }
  return cssTag + html;
}

export { hexToRgb, getLuminance, darkenColor };
